import * as React from 'react';
import { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { UsersListPageWithHistory } from './UserComponents/UsersListPage';
import UserPage from './UserComponents/UserPage';

export interface IUrlParameters {
  userId: string | undefined;
}

interface UsersState {}

export class Users extends Component<
  RouteComponentProps<IUrlParameters>,
  UsersState
> {
  static displayName = Users.name;

  constructor(props: RouteComponentProps<IUrlParameters>) {
    super(props);
  }

  render() {
    if (!this.props.match.params.userId) return <UsersListPageWithHistory />;

    return <UserPage userId={this.props.match.params.userId} />;
  }
}
